// @flow

import * as React from "react";
import { useSelector } from "react-redux";
import actions from "../actions/index.js";

import AccountContent from "./AccountContent.js";
import NotFound from "./NotFound.js";
import usePageFromStore from "../hooks/usePageFromStore.js";

const EAPLanding = (props: PropsType): React.Node => {
    const { eap_pages } = useSelector((state: any): boolean => state.options);
    const { page } = usePageFromStore(
        eap_pages && eap_pages.landing ? eap_pages.landing.url : null
    );
    const breadcrumbs = [
        {
            title: "EAP",
        },
    ];

    if (page && page.url) {
        return <AccountContent page={page} customBreadcrumbs={breadcrumbs} />;
    } else {
        return <NotFound />;
    }
};

EAPLanding.preload = ({ location, passed: { store } }: any): Promise<any> => {
    // const { profile } = store.getState().user;
    const { eap_pages } = store.getState().options;

    if (eap_pages.landing && eap_pages.landing.url) {
        return Promise.all([
            store.dispatch(actions.fetchPage(eap_pages.landing.url)),
        ]);
    } else {
        return Promise.all([]);
    }
};

export default EAPLanding;
